import { fetcher } from '#lib/backendFetcher';

/**
 * Aborts a running Google Maps scraping job.
 * @param {string} jobId - Bull job ID
 * @returns {Promise<Object>}
 */
export const abortGoogleMapsScrapingJob = async (jobId) => {
	const result = await fetcher(`/api/v1/search/maps/scraper/abortSearch/${jobId}`, {
		method: 'POST',
	});
	return result;
};

/**
 * Extends an existing company search with additional results.
 * @param {string} prospectQueryId - UUID of the prospect query
 * @param {number} additionalResults - Number of additional results
 * @param {Object|null} searchParameters - Replacement for the stored query input; null keeps it
 * @param {'maps'|'hr'} searchType - The query's type; the backend validates the replacement against it
 * @returns {Promise<Object>}
 */
export const extendCompanySearch = async (prospectQueryId, additionalResults, searchParameters, searchType) => {
	const body = { prospectQueryId, additionalResults };
	if (searchParameters) Object.assign(body, { searchParameters, searchType });

	return await fetcher('/api/v1/search/unified/extendSearch', {
		method: 'POST',
		body,
	});
};
